import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { CartaServices } from '../../services';
import { CartaCreateDishProdSelectPage } from '../../carta-create/carta-create-dish-prod-select/carta-create-dish-prod-select';
import { ConfigurationImagesPage } from '../../../configuration/configuration-images/configuration-images';

/**
 * Generated class for the MenuXxssPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-carta-template-gladius',
  templateUrl: 'carta-template-gladius.html',
})
export class CartaTemplateGladiusPage {

  @Input() carta_uid: any;
  logo_url: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public cartaServices: CartaServices) {
    this.logo_url = this.getImageUrl(this.globals.restaurant.logo);
  }

  ionViewDidLoad() {
  }

  onBack() {
    this.navCtrl.pop();
  }

  getImageUrl($img_url) {
    if ($img_url != '') {
      $img_url = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/' + encodeURIComponent($img_url) + '?alt=media';
      return $img_url;
    } else {
      return '';
    }
  }

  activePage(number) {
    this.cartaServices.page_active = number;
    this.cartaServices.getIndexOfPage();
    this.cartaServices.cleanEdit();
  }

  previusPage() {
    if (this.cartaServices.page_active > 1) {
      this.cartaServices.page_active -= 1;
    }
    this.cartaServices.getIndexOfPage();
    this.cartaServices.cleanEdit();
  }
  nextPage(number) {
    if (this.cartaServices.page_active < number) {
      this.cartaServices.page_active += 1
    }
    this.cartaServices.getIndexOfPage();
    this.cartaServices.cleanEdit();
  }

  bgImg(img) {
    let _img = this.getImageUrl(img);
    let styles = {
      'background-image': 'url("' + _img + '")',
      'display': 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      'background-position': 'center',
      'background-repeat': 'no-repeat',
      '-webkit-background-size': 'cover',
      '-moz-background-size': 'cover',
      '-o-background-size': 'cover',
      'background-size': 'cover',
      'height': 'auto',
    }
    return styles;
  }

  editElements(section, index) {
    //
    this.cartaServices.edit = true;
    this.cartaServices.edit_section = section;
    this.cartaServices.edit_index = index;
    this.cartaServices.edit_elements_array = this.globals.objectToArray(this.cartaServices.edit_section.elements);
    this.cartaServices.edit_type = 'element';
    //
    this.cartaServices.getIndexOfPage();
    this.navCtrl.push(CartaCreateDishProdSelectPage, {
      update_state: true,
      carta_uid: this.carta_uid,
      section_index: this.cartaServices.edit_index,
      page_index: this.cartaServices.edit_page_index,
      section_complete: this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections,
      section_name: this.cartaServices.edit_section.name,
      new_section: false,
    });
  }

  edit(section, index) {
    this.cartaServices.edit = true;
    this.cartaServices.edit_section = section;
    this.cartaServices.edit_index = index;
    this.cartaServices.edit_type = 'element';
  }

  showDesc(element) {
    switch (this.globals.restaurant.lang) {
      case 'es': {
        if (element.description_es) {
          return true;
        } else {
          return false
        }
      }
      case 'ca': {
        if (element.description_ca) {
          return true;
        } else {
          return false
        }
      }
      case 'en': {
        if (element.description_en) {
          return true;
        } else {
          return false
        }
      }
      case 'de': {
        if (element.description_de) {
          return true;
        } else {
          return false
        }
      }
      case 'fr': {
        if (element.description_fr) {
          return true;
        } else {
          return false
        }
      }
      case 'it': {
        if (element.description_it) {
          return true;
        } else {
          return false
        }
      }
      default: {
        if (element.description_es) {
          return true;
        } else {
          return false
        }
      }
    }
  }

  uploadImage() {
    this.globals.side_menu_config_active = 'images';
    this.navCtrl.push(ConfigurationImagesPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/carta/carta-templates/carta-template-gladius/carta-template-gladius.ts